import URL from "../api_url";

export const XML_UPLOAD_API = `${URL}/xml-upload`;

export const XML_READER_API = `${URL}/xml-reader`;

export const XML_CALIBRATION_API = `${URL}/xml-calibration`;
